var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, PacemEventTarget, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemTitleProxyElement = class PacemTitleProxyElement extends PacemEventTarget {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        this._update();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._update();
    }
    _update() {
        const value = this.value;
        if (Utils.isNullOrEmpty(value) || this.disabled) {
            // No key means do nothing
            return;
        }
        document.title = value;
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTitleProxyElement.prototype, "value", void 0);
PacemTitleProxyElement = __decorate([
    CustomElement({
        tagName: P + '-title-proxy'
    })
], PacemTitleProxyElement);
export { PacemTitleProxyElement };
//}
